import src from '../assets/greensidegolfclub.png';
import { imageLogo } from './imageLogo';

export const GreensideGolfClubLogo = imageLogo({
  src,
  width: 1000,
  height: 313,
  alt: 'Greenside Golf Club',
});
